import {z} from 'zod';

// Enums

export const DiscountApplicationMethodSchema = z.enum([
  'DISCOUNT_APPLICATION_ON_TOTAL_SELLING_PRICE',
  'DISCOUNT_APPLICATION_ON_UNIT_SELLING_PRICE',
]);

export const DiscountRoundTypeSchema = z.enum([
  'ALGEBRAIC',
  'CEILING',
  'DOWN',
  'FLOOR',
  'HALF_DOWN',
  'HALF_EVEN',
  'HALF_UP',
  'UP',
]);

// Request/Response Body Schemas

const ROUND_STEP_PATTERN = /^(?:[0-9]+\.[0-9]+|[0-9]+)$/;

export const DiscountValiditySchema = z.object({
  roundType: DiscountRoundTypeSchema,
  roundStep: z.string().regex(ROUND_STEP_PATTERN),
  validFrom: z.string(),
});

export const DiscountApplicationMethodSettingsSchema = z.object({
  applicationMethod: DiscountApplicationMethodSchema,
  validities: z.array(DiscountValiditySchema),
});

// API Response Schemas

// The endpoint answers 204 with no body when the tenant has never configured this,
// so the response must tolerate an absent value.
export const GetDiscountApplicationMethodApiResponseSchema =
  DiscountApplicationMethodSettingsSchema.nullish(); // status 200 | 204
export const UpdateDiscountApplicationMethodApiResponseSchema = z.void(); // status 204

// API Arguments Schemas

export const UpdateDiscountApplicationMethodApiArgSchema = DiscountApplicationMethodSettingsSchema;

// Exported Types (Inferred)

export type DiscountApplicationMethod = z.infer<typeof DiscountApplicationMethodSchema>;
export type DiscountRoundType = z.infer<typeof DiscountRoundTypeSchema>;
export type DiscountValidity = z.infer<typeof DiscountValiditySchema>;
export type DiscountApplicationMethodSettings = z.infer<
  typeof DiscountApplicationMethodSettingsSchema
>;

// API Response Types

export type GetDiscountApplicationMethodApiResponse = z.infer<
  typeof GetDiscountApplicationMethodApiResponseSchema
>;
export type UpdateDiscountApplicationMethodApiResponse = z.infer<
  typeof UpdateDiscountApplicationMethodApiResponseSchema
>;

// API Argument Types

export type UpdateDiscountApplicationMethodApiArg = z.infer<
  typeof UpdateDiscountApplicationMethodApiArgSchema
>;
